





































































































import { Component } from "vue-property-decorator";
import Vue from "vue";
import CardListPasienRanap from "@/components/dashboard/CardListPasienRanap.vue";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { pusher } from "@/services/PusherClient";
import ListPasien from "@/services/ListPasien";
import EncounterIndex from "@/services/EncounterIndex";
import { storeUnit } from "@/store/modules/unit";

@Component({
  components: {
    CardListPasienRanap
  },
  beforeRouteLeave(to, from, next) {
    pusher.unsubscribe(`pemeriksaan.unit.${this.sess_login["unit_id"]}`);

    next();
  }
})
export default class DaftarPasien extends Vue {
  cm = "";
  pasien: Array<object> = [];
  hdn = "";
  loading = true;
  showFilterDokter = true;
  errListPx = "0";
  errPx = "0";
  reg = "";
  sess_login = this.stateuser;
  today = new Date().toISOString().substr(0, 10);
  dataList = [];
  tanggal = new Date().toISOString().substr(0, 10);
  cdocId = "40";
  selectedUnit = null;
  searchPx = "";

  mounted() {
    if (this.stateuser.unit_id == "27") {
      this.cdocId = "40";
    } else if (this.stateuser.unit_id == "2L") {
      this.cdocId = "T37";
    } else if (this.stateuser.unit_id == "38") {
      this.cdocId = "85";
    } else {
      this.cdocId = "";
    }

    appModule.setLoading(true);
    this.getList();
  }

  get stateuser() {
    return userModule.user;
  }

  get showLoading() {
    return appModule.loading;
  }

  get headers() {
    const headers = [
      { text: "Unit", value: "unit.nama" },
      { text: "No. RM", value: "pasien.rm" },
      { text: "Nama", value: "pasien.nama", width: "20vh" },
      { text: "Jk", value: "pasien.sex" },
      { text: "Umur (th)", value: "pasien.umur.th", align: "center" },
      { text: "Tgl Masuk", value: "tgl_in", width: "10vh" },
      { text: "DPJP", value: "dokter.nama" },
      { text: "Jaminan", value: "cara_bayar.nama" },
      { text: "", value: "action" }
    ];

    return headers;
  }

  get listPasien() {
    return this.dataList.filter(item => {
      let rule =
        item.pasien.nama.toLowerCase().includes(this.searchPx) ||
        item.pasien.rm.includes(this.searchPx);

      if (this.selectedUnit) {
        rule = rule && item.unit.id == this.selectedUnit;
      }

      return rule;
    });
  }

  get unitRanapOptions() {
    return storeUnit.unitRanap;
  }

  getList() {
    this.loading = true;

    ListPasien.getListPasienByTanggalDokter(
      this.tanggal,
      this.cdocId,
      this.selectedUnit
    )
      .then(resp => {
        this.dataList = resp.data;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  reloadListPx() {
    this.errListPx = "0";
    this.getList();
  }

  async goToPemeriksaan(rm, registerId) {
    await EncounterIndex.regRanap(registerId, rm).catch(() => undefined);

    this.$router.push({
      name: `pemeriksaan-ranap`,
      params: {
        register: registerId,
        rm: rm
      }
    });
  }
}
